
import { createContext } from "react";
import { AuthContextType } from "../types/AuthContextType";
export const AuthSegmentContext = createContext<AuthContextType | null>(null);
